var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkyscrapers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 381,
    height: 173,
    viewBox: "0 0 381 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M381 172.749V144.105H368.476V149.834H364.081V138.375H348.041V149.834H344.523V141.02H341.007V88.1358H336.613V54.6435H315.301L315.523 95.0158L301.302 95.1878V62.8606H279.268V97.2201L272.676 97.4408V62.7977H264.986V48.0328H260.372V38.1169H242.354V48.0328H237.74V62.7965H230.051V81.5643L226.501 81.7861L225.437 26.1852H201.706V55.7611L193.356 55.9818V9.75346H190.5V0H165.452V9.75578H162.595V82.5217H157.322V52.6243H152.927V43.1247H146.555V15.3984H137.328V43.1247H130.956V52.6243H126.561V85.4877H123.485L121.068 85.4557V47.3827L56.0294 48.0056V133.747H50.5341V122.51H30.7606V144.102H25.0476V136.17H12.5238V152.255H0V172.747L381 172.749Z",
    fill: "#9BA2AE"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0932 54.2188H61.3962V64.2154H69.0932V54.2188Z",
    fill: "#9BA2AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0932 86.374H61.3962V96.3706H69.0932V86.374Z",
    fill: "#9BA2AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9183 54.2188H73.2214V64.2154H80.9183V54.2188Z",
    fill: "#9BA2AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92.745 54.2188H85.0481V64.2154H92.745V54.2188Z",
    fill: "#9BA2AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M92.745 108.132H85.0481V118.128H92.745V108.132Z",
    fill: "#9BA2AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9183 70.17H73.2214V80.1667H80.9183V70.17Z",
    fill: "#9BA2AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9183 125.208H73.2214V135.204H80.9183V125.208Z",
    fill: "#9BA2AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M80.9183 86.374H73.2214V96.3706H80.9183V86.374Z",
    fill: "#9BA2AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M102.909 86.374H95.2119V96.3706H102.909V86.374Z",
    fill: "#9BA2AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M102.909 125.208H95.2119V135.204H102.909V125.208Z",
    fill: "#9BA2AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M112.585 54.2188H104.888V64.2154H112.585V54.2188Z",
    fill: "#9BA2AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M171.566 14.5667H167.29V20.1203H171.566V14.5667Z",
    fill: "#9BA2AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M180.46 14.5667H176.183V20.1203H180.46V14.5667Z",
    fill: "#9BA2AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M171.566 24.3676H167.29V29.9212H171.566V24.3676Z",
    fill: "#9BA2AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M189.351 24.3676H185.076V29.9212H189.351V24.3676Z",
    fill: "#9BA2AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M180.46 34.1685H176.183V39.7221H180.46V34.1685Z",
    fill: "#9BA2AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M189.351 34.1685H185.076V39.7221H189.351V34.1685Z",
    fill: "#9BA2AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M171.566 43.9694H167.29V49.523H171.566V43.9694Z",
    fill: "#9BA2AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M189.351 43.9694H185.076V49.523H189.351V43.9694Z",
    fill: "#9BA2AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M171.566 53.7704H167.29V59.324H171.566V53.7704Z",
    fill: "#9BA2AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M180.46 53.7704H176.183V59.324H180.46V53.7704Z",
    fill: "#9BA2AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M189.351 63.5712H185.076V69.1248H189.351V63.5712Z",
    fill: "#9BA2AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M171.566 83.1731H167.29V88.7267H171.566V83.1731Z",
    fill: "#9BA2AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M240.833 66.7888H236.558V72.3424H240.833V66.7888Z",
    fill: "#9BA2AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M264.582 66.7888H260.307V72.3424H264.582V66.7888Z",
    fill: "#9BA2AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M252.39 51.7048H248.115V57.2584H252.39V51.7048Z",
    fill: "#9BA2AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M321.104 60.0844H316.829V65.6379H321.104V60.0844Z",
    fill: "#9BA2AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M335.402 60.0844H331.127V65.6379H335.402V60.0844Z",
    fill: "#9BA2AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M335.402 69.9838H331.127V75.5374H335.402V69.9838Z",
    fill: "#9BA2AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M321.104 79.882H316.829V85.4355H321.104V79.882Z",
    fill: "#9BA2AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M335.402 79.882H331.127V85.4355H335.402V79.882Z",
    fill: "#9BA2AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M321.104 89.7814H316.829V95.3349H321.104V89.7814Z",
    fill: "#9BA2AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M328.254 99.6795H323.979V105.233H328.254V99.6795Z",
    fill: "#9BA2AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M335.402 99.6795H331.127V105.233H335.402V99.6795Z",
    fill: "#9BA2AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M335.402 109.579H331.127V115.133H335.402V109.579Z",
    fill: "#9BA2AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M321.104 119.478H316.829V125.032H321.104V119.478Z",
    fill: "#9BA2AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M328.254 119.478H323.979V125.032H328.254V119.478Z",
    fill: "#9BA2AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M261.576 51.7048H257.299V57.2584H261.576V51.7048Z",
    fill: "#9BA2AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M240.833 77.9624H236.558V83.516H240.833V77.9624Z",
    fill: "#9BA2AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M248.748 77.9624H244.473V83.516H248.748V77.9624Z",
    fill: "#9BA2AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M240.833 89.1348H236.558V94.6883H240.833V89.1348Z",
    fill: "#9BA2AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M256.666 89.1348H252.391V94.6883H256.666V89.1348Z",
    fill: "#9BA2AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M264.582 89.1348H260.307V94.6883H264.582V89.1348Z",
    fill: "#9BA2AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M248.748 100.308H244.473V105.862H248.748V100.308Z",
    fill: "#9BA2AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M240.833 111.481H236.558V117.034H240.833V111.481Z",
    fill: "#9BA2AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M256.666 111.481H252.391V117.034H256.666V111.481Z",
    fill: "#9BA2AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M264.582 111.481H260.307V117.034H264.582V111.481Z",
    fill: "#9BA2AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M240.833 133.828H236.558V139.382H240.833V133.828Z",
    fill: "#9BA2AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M256.666 133.828H252.391V139.382H256.666V133.828Z",
    fill: "#9BA2AE"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M112.585 108.132H104.888V118.128H112.585V108.132Z",
    fill: "#9BA2AE"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M153.241 56.8289H129.639V59.4022H153.241V56.8289Z",
    fill: "#9BA2AE"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M222.923 49.542H203.743V52.1153H222.923V49.542Z",
    fill: "#9BA2AE"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M222.923 55.0944H203.743V57.6677H222.923V55.0944Z",
    fill: "#9BA2AE"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M222.923 71.7539H203.743V74.3272H222.923V71.7539Z",
    fill: "#9BA2AE"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M299.777 66.7888H280.598V69.3621H299.777V66.7888Z",
    fill: "#9BA2AE"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M299.777 72.3424H280.598V74.9145H299.777V72.3424Z",
    fill: "#9BA2AE"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M299.777 83.4483H280.598V86.0216H299.777V83.4483Z",
    fill: "#9BA2AE"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M299.777 100.108H280.598V102.681H299.777V100.108Z",
    fill: "#9BA2AE"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M299.777 111.214H280.598V113.787H299.777V111.214Z",
    fill: "#9BA2AE"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M299.777 122.32H280.598V124.892H299.777V122.32Z",
    fill: "#9BA2AE"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M299.777 133.427H280.598V136H299.777V133.427Z",
    fill: "#9BA2AE"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M222.923 88.4135H203.743V90.9868H222.923V88.4135Z",
    fill: "#9BA2AE"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M222.923 99.5194H203.743V102.093H222.923V99.5194Z",
    fill: "#9BA2AE"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M153.241 64.2167H129.639V66.79H153.241V64.2167Z",
    fill: "#9BA2AE"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M153.241 71.6033H129.639V74.1766H153.241V71.6033Z",
    fill: "#9BA2AE"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M153.241 86.3787H129.639V88.952H153.241V86.3787Z",
    fill: "#9BA2AE"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M153.241 101.153H129.639V103.726H153.241V101.153Z",
    fill: "#9BA2AE"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M153.241 108.541H129.639V111.114H153.241V108.541Z",
    fill: "#9BA2AE"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M153.241 123.316H129.639V125.89H153.241V123.316Z",
    fill: "#9BA2AE"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M153.241 138.091H129.639V140.664H153.241V138.091Z",
    fill: "#9BA2AE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkyscrapers);
export default __webpack_public_path__ + "static/media/skyscrapers.59e13eddc3e3585cf71f8ceea2c49761.svg";
export { ForwardRef as ReactComponent };